export const PRENOTAZIONE_SCOMMESSA_CODICESESSIONE = 'prenotazione-scommessa-codicesessione';
